export const BreakPoints = {
  xs: 0,
  sm: 768,
  md: 900,
  lg: 1200,
  xl: 1536,
};
